import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=b1df2920&scoped=true&"
import script from "./Quotes.vue?vue&type=script&lang=js&"
export * from "./Quotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1df2920",
  null
  
)

export default component.exports